<template>
    <Modal ref="Modal" :title="$t('labels.export_clients')">
        <div class="modal-body">
            <slot v-if="!isLoading">
                <p>{{ $t('labels.clients_for_export') }} <strong>{{ totalClients }}</strong>. {{ $t('labels.fields_for_export') }}:</p>
                <ol class="list pl-2 ml-2">
                    <li> {{ $t("labels.id") }}</li>
                    <li> {{ $t("labels.name") }}</li>
                    <li> {{ $t("labels.phone") }}</li>
                    <li> {{ $t("labels.email") }}</li>
                    <li> {{ $t("labels.created_at") }}</li>
                </ol>
            </slot>
            <slot v-else>
                <TaskProgressBar :done="exportedPages" :total="totalPages"/>
            </slot>
        </div>
        <div class="modal-footer">
            <Button color="indigo" @click="exportClients">
                {{ $t('buttons.export') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import Button from '../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../components/new/progress/TaskProgressBar.vue';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: 'ExportClientsModal',
    components: {
        Modal, Button, TaskProgressBar
    },
    data() {
        return {
            exportedPages: 0,
            totalPages: 0,
            isLoading: false,
            totalClients: 0
        }
    },
    methods: {
        async show() {
            this.$refs.Modal.show();

            await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/clients`, {
                limit: 1
            }).then((response) => {
                this.totalClients = response.data.meta.total;
            });
            
            this.isLoading = false;
        },
        async exportClients() {
            this.isLoading = true;
            this.exportedPages = 0;

            let clientsData = [];

            const limit = 100; // Clients per page
            const totalPages = Math.ceil(this.totalClients / limit);

            this.totalPages = totalPages;

            try {
                for (let page = 1; page <= totalPages; page++) {
                    const response = await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/clients`, {
                        page: page,
                        limit: limit,
                        orders: [{
                            column: 'id',
                            dir: 'asc'
                        }]
                    });

                    response.data.data.forEach(client => {
                        clientsData.push({
                            id: client.id,
                            name: client.name,
                            phone: client.phone,
                            email: client.email,
                            created_at: client.created_at
                        });
                    })
                    
                    this.exportedPages = page;
                }
                
                // Generate CSV
                this.downloadCSV(clientsData);
                
            } catch (error) {
                console.error('Error exporting clients:', error);
            } finally {
                this.$refs.Modal.hide();
                this.isLoading = false;
            }
        },
        downloadCSV(clientsData) {
            // Using PapaParse to convert to CSV
            const csv = Papa.unparse(clientsData);
            
            // Creating and downloading file using FileSaver
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `clients_export_${new Date().toISOString().slice(0, 10)}.csv`);
        }
    }
}
</script>